import * as React from 'react';
import cx from 'classnames';
import { Select, Tooltip } from 'antd';
import { EditorState } from 'draft-js';
import { FontIcon } from '@revfluence/fresh-icons/regular/esm';

import { TFontFamily, TFontSize } from './types';

import styles from './FontControls.module.scss';

const { Option } = Select;

const FONT_FAMILIES: { value: TFontFamily; label: string }[] = [
  { value: 'Arial', label: 'Arial' },
  { value: 'Helvetica', label: 'Helvetica' },
  { value: 'Georgia', label: 'Georgia' },
  { value: 'Times New Roman', label: 'Times New Roman' },
  { value: 'Courier New', label: 'Courier New' },
  { value: 'Verdana', label: 'Verdana' },
  { value: 'Trebuchet MS', label: 'Trebuchet MS' },
];

const FONT_SIZES: { value: TFontSize; label: string }[] = [
  { value: '12px', label: '12' },
  { value: '14px', label: '14' },
  { value: '16px', label: '16' },
  { value: '18px', label: '18' },
  { value: '20px', label: '20' },
  { value: '24px', label: '24' },
  { value: '28px', label: '28' },
  { value: '32px', label: '32' },
];

interface IProps {
  editorState: EditorState;
  currentFont?: TFontFamily;
  currentSize?: TFontSize;
  onFontChange(font: TFontFamily): void;
  onSizeChange(size: TFontSize): void;
  className?: string;
}

export const FontControls: React.FC<IProps> = React.memo((props) => {
  const { currentFont = 'Arial', currentSize = '14px' } = props;

  return (
    <div className={cx(styles.FontControls, props.className)}>
      <Tooltip title="Font Family">
        <Select
          value={currentFont}
          onChange={props.onFontChange}
          className={styles.fontSelect}
          size="small"
          suffixIcon={<FontIcon width={12} height={12} />}
        >
          {FONT_FAMILIES.map(({ value, label }) => (
            <Option key={value} value={value}>
              <span style={{ fontFamily: value }}>{label}</span>
            </Option>
          ))}
        </Select>
      </Tooltip>

      <Tooltip title="Font Size">
        <Select
          value={currentSize}
          onChange={props.onSizeChange}
          className={styles.sizeSelect}
          size="small"
        >
          {FONT_SIZES.map(({ value, label }) => (
            <Option key={value} value={value}>
              {label}
            </Option>
          ))}
        </Select>
      </Tooltip>
    </div>
  );
});

FontControls.displayName = 'FontControls';
